import { render, staticRenderFns } from "./yxjshcw.vue?vue&type=template&id=cdf1e63c&scoped=true&"
import script from "./yxjshcw.vue?vue&type=script&lang=js&"
export * from "./yxjshcw.vue?vue&type=script&lang=js&"
import style0 from "./yxjshcw.vue?vue&type=style&index=0&id=cdf1e63c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf1e63c",
  null
  
)

export default component.exports